export enum CancelAppointmentReason {
  RESCHEDULE = 'needs-to-reschedule',
  ALREADY_AWARE = 'already-aware-of-result',
  ALREADY_RECEIVED = 'already-received-gc',
  NOT_INTERESTED = 'not-interested',
  OTHER = 'other',
}

export interface CancelAppointmentFormValues {
  reason: string;
  otherReason?: string;
}

export interface CancelAppointmentModalProps {
  id: string;
  isOpen: boolean;
  onClose: () => void;
}
